import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

const App = (props) => {
    //const [isLoggedIn, setIsLoggedIn] = React.useState(true);
    const location = useLocation();
    React.useEffect(() => {
        //setIsLoggedIn(localStorage.getItem('isLoggedIn'));
    }, [location]);
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    return (
        <Switch>
            {isLoggedIn ? (
                <Route path="/" render={(props) => <AdminLayout {...props} />} />
            ) : (
                <Route path="/" render={(props) => <AuthLayout {...props} />} />
            )}
        </Switch>
    )
};

export default App;